import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { ABILITY_ISSUE, INTENTION_ISSUE, ISSUE_TYPE, strings } from '@constants'
import { Spacings, Text } from '@styles'
import { getTodayDate } from '@utils'
import { RadioButton } from '@base'
import { Calendar, Input, Select, Textarea } from '@baseV2'

import { InputsWrapper } from '../styles'

const Heading = styled.div`
	font-size: ${Text.SMALL};
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.primary};
`

const RadioRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_6B};
`

const RadioOption = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

const RadioLabel = styled.label`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.colors.text.primary};
	cursor: pointer;
	user-select: none;
`

const Row = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${Spacings.SPACING_3B};
`

const getDate = (date) => (+date === 0 ? new Date().getTime() : +date)

const EditCollection = ({ isEdit, isAddRemark, onChange, state }) => {
	const [issueType, setIssueType] = useState(state?.issue?.value || ISSUE_TYPE.INTENTION)

	const intentionTypes = Object.entries(INTENTION_ISSUE).map(([key, value]) => ({ key, label: value }))
	const abilityTypes = Object.entries(ABILITY_ISSUE).map(([key, value]) => ({ key, label: value }))

	const setIssueTypeFunc = (value) => {
		setIssueType(value)
		onChange('issue')(value)
		onChange('reason')({})
	}

	useEffect(() => {
		if (isAddRemark) setIssueTypeFunc(ISSUE_TYPE.INTENTION)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<InputsWrapper>
			<Heading>{`${strings('issue')}: `}</Heading>
			<RadioRow>
				<RadioOption>
					<RadioButton
						id='intention-radio'
						size='1.125'
						checked={issueType === ISSUE_TYPE.INTENTION}
						value={ISSUE_TYPE.INTENTION}
						onChange={() => setIssueTypeFunc(ISSUE_TYPE.INTENTION)}
					/>
					<RadioLabel htmlFor='intention-radio'>Intention</RadioLabel>
				</RadioOption>
				<RadioOption>
					<RadioButton
						id='ability-radio'
						size='1.125'
						checked={issueType === ISSUE_TYPE.ABILITY}
						value={ISSUE_TYPE.ABILITY}
						onChange={() => setIssueTypeFunc(ISSUE_TYPE.ABILITY)}
					/>
					<RadioLabel htmlFor='ability-radio'>Ability</RadioLabel>
				</RadioOption>
			</RadioRow>

			{issueType === ISSUE_TYPE.INTENTION && (
				<Select
					id={state.reason.id}
					data={intentionTypes}
					value={state?.reason?.value}
					placeholder={strings(['select', 'intention', 'issue'])}
					displayKey={state.reason.displayKey}
					primaryKey={state.reason.primaryKey}
					onChange={onChange('reason')}
				/>
			)}

			{issueType === ISSUE_TYPE.ABILITY && (
				<>
					<Select
						id='reason'
						data={abilityTypes}
						value={state?.reason?.value}
						placeholder={strings(['select', 'ability', 'issue'])}
						displayKey={state.reason.displayKey}
						primaryKey={state.reason.primaryKey}
						onChange={onChange('reason')}
					/>
					<Input label={state.pdc.label} value={state?.pdc?.value} onChange={(e) => onChange('pdc')(e.target.value)} />
					<Input
						label='Ask for project details & principal'
						value={state.principal_details.value}
						onChange={(e) => onChange('principal_details')(e.target.value)}
					/>
					<Select
						label={state.reason_for_delay.label}
						data={state.reason_for_delay.data}
						disabled={state.reason_for_delay.disabled}
						value={state?.reason_for_delay?.value}
						displayKey={state.reason_for_delay.displayKey}
						primaryKey={state.reason_for_delay.primaryKey}
						onChange={onChange('reason_for_delay')}
					/>
					{state?.reason?.value?.key === Object.keys(ABILITY_ISSUE)[1] && (
						<Input
							label={state.partial_payment_agreement?.label}
							value={state.partial_payment_agreement?.value}
							onChange={(e) => onChange('partial_payment_agreement')(e.target.value)}
						/>
					)}
				</>
			)}

			<Heading>{strings('collection_customer_detail_header')}</Heading>
			<Input
				label={state.customer_poc_name.label}
				value={state?.customer_poc_name?.value}
				onChange={(e) => onChange('customer_poc_name')(e.target.value)}
			/>
			<Row>
				<Input
					type='tel'
					label={state.customer_poc_phone.label}
					value={state?.customer_poc_phone?.value}
					maxLength={10}
					onChange={(e) => onChange('customer_poc_phone')(e.target.value)}
					placeholder={state.customer_poc_phone.placeholder}
				/>
				<Input
					type='email'
					label={state.customer_poc_email.label}
					value={state?.customer_poc_email?.value}
					onChange={(e) => onChange('customer_poc_email')(e.target.value)}
				/>
			</Row>

			<Heading>{strings('collection_meeting_schedule_header')}</Heading>
			<Calendar
				label='Date'
				value={getDate(state?.meeting_scheduled_at?.value)}
				placeholder={state.meeting_scheduled_at.placeholder}
				minDate={getTodayDate(false).getTime() - 86400000 * 3}
				onChange={onChange('meeting_scheduled_at')}
			/>
			<Input
				label='Remarks from the meeting'
				value={state?.meeting_remarks?.value || ''}
				onChange={(e) => onChange('meeting_remarks')(e.target.value)}
			/>
			<Heading>{strings('collection_add_remark_header')}</Heading>
			<Textarea
				id={state.remark_message.id}
				label={state.remark_message.label}
				rows={3}
				value={state?.remark_message?.value}
				onChange={(e) => onChange('remark_message')(e.target.value)}
			/>
		</InputsWrapper>
	)
}

export default EditCollection
